import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    filter: (page: number, size: number, unitTypeKeys?: string[]) =>
    {
      const filtercarClassification = unitTypeKeys?.filter(u => u !=='NOVELTY')
     var params = new URLSearchParams();
     if(unitTypeKeys?.includes('NOVELTY')){
      params.append("novelty.equals", "true");
     }
     if(filtercarClassification && filtercarClassification.length){
      params.append("carClassification.in", filtercarClassification.join(','));
     }

     params.append("available.equals", "true");
     params.append("sort", "novelty,desc");
     params.append("sort","carClassification");
     params.append("sort","model");

     params.append("page",page?.toString())
     params.append("size",size?.toString())

      return  AxiosInstance.get<any[]>(`${Config.core.unitTypes}`,
      {params}
    );

    }

}
